import { Component, Input } from '@angular/core';
import { AnimateOnScrollDirective } from '../../../../Shared/directives/AnimateOnScroll/animate-on-scroll.directive';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { CountUpModule } from 'ngx-countup';

@Component({
    selector: 'app-about-us',
        standalone: true,
templateUrl: './about-us-new.component.html',
    styleUrls: ['./about-us-new.component.scss'],
    imports: [RouterLink, CountUpModule, TranslatePipe]
})
export class AboutUsComponent {
  @Input() data: any;
  @Input() translations: any;
}
